<template>
    <div class="parking-list__card" @click="clickParking(parking)">
        <div class="parking-list__col parking-list__col-1">
            <ParkingIco v-if="parking.isParking" />
            <PantryIco v-if="!parking.isParking" />
        </div>
        <div class="parking-list__col parking-list__col-2">
            {{parking.title}}
        </div>
        <div class="parking-list__col parking-list__col-3">
            {{parking.area || '?'}}
            <span class="is-mobile">м<sup>2</sup></span>
        </div>
        <div class="parking-list__col parking-list__col-4">
            <span class="is-mobile">Корпус</span> {{parking.buildingTitle}}
        </div>
        <div class="parking-list__col parking-list__col-5">
            <div class="parking-list__col-price">{{prettyPrice(parking.price)}} <span class="is-mobile">руб</span></div>
            <div v-if="parking.priceOld" class="parking-list__col-old">
                {{prettyPrice(parking.priceOld)}} <span class="is-mobile">руб</span>
            </div>
            <div v-if="parking.action" class="parking-list__col-action">-{{parking.action}}%</div>
        </div>
    </div>
</template>

<style lang='scss'>
    @import "./ParkingListCard.scss";
</style>

<script>
import Observer from 'common/scripts/observer';
import PantryIco from './img/pantry-ico.vue';
import ParkingIco from './img/parking-ico';
import Utils from 'common/scripts/utils';

const observer = new Observer();

export default {
    props: ['parking'],

    components: {
        PantryIco,
        ParkingIco
    },

    methods: {
        convertToDigit(value) {
            return Utils.convertToDigit(value);
        },

        prettyPrice(price) {
            if (Number(price)) {
                return `${this.convertToDigit(price)}`;
            }

            return price;
        },

        clickParking(parking) {
            if (!parking.isBooked && !parking.isSold) {
                observer.publish('parkingClick', {
                    element: parking.id,
                    title  : parking.title
                });
            }
        }
    }
};

</script>
